import { Box, chakra, Checkbox, Flex, Image } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import config from "@/config";
import { themeStore } from "@/stores/theme";
import { albumStore } from "@/modules/album/store";
import { useMemo } from "react";
interface Props {
  opMode: boolean;
  onToggle: (id: number) => void;
  src: string;
  like: number;
  isLike: boolean;
  avatar: string;
  username: string;
  id: number;
  imageId?: number;
  sourceType: string;
  onClick?: (imgId?: number) => void;
}

const WaterFlowCard = chakra((props: Props) => {
  const {
    id,
    imageId,
    opMode,
    src,
    onToggle,
    like,
    isLike,
    avatar,
    username,
    sourceType,
    onClick = () => null,
    ...other
  } = props;
  const { themeColor } = themeStore.styles;
  const isChecked = albumStore.imageBatchOpSet.has(id);
  return (
    <Box
      className="album__waterflow-item"
      pos="absolute"
      overflow="hidden"
      rounded="20px"
      border="2px solid"
      borderColor={opMode ? "#999999" : "transparent"}
      _hover={{ borderColor: "#07f79a" }}
      cursor="pointer"
      onClick={() => onClick(imageId)}
      {...other}
      css={{
        "&:hover .album__waterflow-itemInfo": {
          visibility: "visible",
        },
      }}
    >
      <Image src={src} w="100%" />
      {opMode ? null : (
        <Flex
          className="album__waterflow-itemInfo"
          pos="absolute"
          bottom="0"
          h="58px"
          align="center"
          justify="space-between"
          w="100%"
          visibility="hidden"
          onClick={(e) => e.stopPropagation()}
        >
          <Box boxSize="34px" rounded="8px" overflow="hidden" ml="12px">
            <Image src={avatar} />
          </Box>
          {sourceType === "finished" ? (
            <Flex
              h="34px"
              minW={50}
              justify="center"
              align="center"
              bg="#13141b88"
              mr="12px"
              p="8px"
              rounded="8px"
              color="white"
              cursor="pointer"
              onClick={() => albumStore.onThumbsUp(imageId)}
            >
              <Image
                w="1em"
                h="1em"
                src={
                  !isLike
                    ? `${config.buildCdnBaseUrl}assets/creator/giveTheThumbsUp.png`
                    : `${config.buildCdnBaseUrl}assets/creator/activeGiveTheThumbsUp.png`
                }
                mr="1em"
              />
              {like}
            </Flex>
          ) : null}
        </Flex>
      )}
      {opMode ? (
        <Box
          pos="absolute"
          top="0"
          left="0"
          w="100%"
          h="100%"
          onClick={(e) => {
            e.stopPropagation();
            onToggle(id);
          }}
        >
          <Checkbox
            pos="absolute"
            size="lg"
            _checked={{
              "& .chakra-checkbox__control, & .chakra-checkbox__control:hover": {
                bg: themeColor,
                borderColor: "white",
              },
            }}
            css={{
              "&:hover .chakra-checkbox__control,& .chakra-checkbox__control": {
                rounded: "4px",
              },
            }}
            right="12px"
            top="12px"
            isChecked={isChecked}
            onChange={(e) => {
              e.stopPropagation();
              onToggle(id);
            }}
          ></Checkbox>
        </Box>
      ) : null}
    </Box>
  );
});

export default observer(WaterFlowCard);
